import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RoleProvider } from './context/RoleContext';
import { Toaster } from './components/ui/toaster';

import RoleSelection from './pages/RoleSelection';
import SchoolOverview from './pages/school/SchoolOverview';
import SchoolExperiences from './pages/school/SchoolExperiences';
import SchoolWebLearningHub from './pages/school/SchoolWebLearningHub';
import SchoolHowItWorks from './pages/school/SchoolHowItWorks';
import SchoolDeployment from './pages/school/SchoolDeployment';
import SchoolEvidence from './pages/school/SchoolEvidence';
import SchoolFAQ from './pages/school/SchoolFAQ';
import SchoolRequestDemo from './pages/school/SchoolRequestDemo';
import SchoolStartDeployment from './pages/school/SchoolStartDeployment';
import StudentOverview from './pages/student/StudentOverview';
import StudentExperiences from './pages/student/StudentExperiences';
import StudentLearningHub from './pages/student/StudentLearningHub';
import StudentHowItWorks from './pages/student/StudentHowItWorks';
import StudentAccess from './pages/student/StudentAccess';
import StudentFAQ from './pages/student/StudentFAQ';
import AccessRequest from './pages/student/AccessRequest';
import ResearcherOverview from './pages/researcher/ResearcherOverview';
import ResearcherActivities from './pages/researcher/ResearcherActivities';
import ResearcherEvidence from './pages/researcher/ResearcherEvidence';
import ResearcherCollaborate from './pages/researcher/ResearcherCollaborate';
import CoachingOverview from './pages/coaching/CoachingOverview';
import CoachingEvidence from './pages/coaching/CoachingEvidence';
import CoachingAdoption from './pages/coaching/CoachingAdoption';
import CoachingRequestAdoption from './pages/coaching/CoachingRequestAdoption';
import CoachingVRExperiences from './pages/coaching/CoachingVRExperiences';
import CoachingLearningHub from './pages/coaching/CoachingLearningHub';
import PartnersOverview from './pages/partners/PartnersOverview';
import PartnershipModels from './pages/partners/PartnershipModels';
import PartnershipRequest from './pages/partners/PartnershipRequest';
import ExploreOverview from './pages/explore/ExploreOverview';
import ExploreVRExperiences from './pages/explore/ExploreVRExperiences';
import ExploreWebLearningHub from './pages/explore/ExploreWebLearningHub';
import ExploreAccessRequest from './pages/explore/ExploreAccessRequest';

import About from './pages/shared/About';
import Team from './pages/shared/Team';
import Insights from './pages/shared/Insights';
import InsightArticle from './pages/shared/InsightArticle';
import News from './pages/shared/News';
import Careers from './pages/shared/Careers';
import MediaContact from './pages/shared/MediaContact';
import ProjectOverview from './pages/shared/ProjectOverview';
import LogoAssets from './pages/shared/LogoAssets';
import FAQ from './pages/shared/FAQ';

import FormPage from './pages/forms/FormPage';

function App() {
  return (
    <div className="App">
      <RoleProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RoleSelection />} />
            <Route path="/school" element={<SchoolOverview />} />
            <Route path="/school/experiences" element={<SchoolExperiences />} />
            <Route path="/school/web-learning-hub" element={<SchoolWebLearningHub />} />
            <Route path="/school/how-it-works" element={<SchoolHowItWorks />} />
            <Route path="/school/deployment" element={<SchoolDeployment />} />
            <Route path="/school/evidence" element={<SchoolEvidence />} />
            <Route path="/school/faq" element={<SchoolFAQ />} />
            <Route path="/school/request-demo" element={<SchoolRequestDemo />} />
            <Route path="/school/start-deployment" element={<SchoolStartDeployment />} />
            <Route path="/student-parent" element={<StudentOverview />} />
            <Route path="/student-parent/experiences" element={<StudentExperiences />} />
            <Route path="/student-parent/learning-hub" element={<StudentLearningHub />} />
            <Route path="/student-parent/how-it-works" element={<StudentHowItWorks />} />
            <Route path="/student-parent/access" element={<StudentAccess />} />
            <Route path="/student-parent/faqs" element={<StudentFAQ />} />
            <Route path="/access-request" element={<AccessRequest />} />
            <Route path="/researcher" element={<ResearcherOverview />} />
            <Route path="/researcher/activities" element={<ResearcherActivities />} />
            <Route path="/researcher/evidence" element={<ResearcherEvidence />} />
            <Route path="/researcher/collaborate" element={<ResearcherCollaborate />} />
            <Route path="/coaching" element={<CoachingOverview />} />
            <Route path="/coaching/evidence" element={<CoachingEvidence />} />
            <Route path="/coaching/vr-experiences" element={<CoachingVRExperiences />} />
            <Route path="/coaching/learning-hub" element={<CoachingLearningHub />} />
            <Route path="/coaching/deployment" element={<CoachingAdoption />} />
            <Route path="/coaching/request-adoption" element={<CoachingRequestAdoption />} />
            <Route path="/partners" element={<PartnersOverview />} />
            <Route path="/partners/models" element={<PartnershipModels />} />
            <Route path="/explore" element={<ExploreOverview />} />
            <Route path="/explore/vr-experiences"   element={<ExploreVRExperiences />} />
            <Route path="/explore/web-learning-hub" element={<ExploreWebLearningHub />} />
            <Route path="/explore/access-request"   element={<ExploreAccessRequest />} />

            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightArticle />} />
            <Route path="/news" element={<News />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<MediaContact />} />
            <Route path="/project-overview" element={<ProjectOverview />} />
            <Route path="/logo-assets" element={<LogoAssets />} />
            <Route path="/faq" element={<FAQ />} />

            <Route path="/request-demo" element={<FormPage kind="request-demo" />} />
            <Route path="/start-deployment" element={<FormPage kind="start-deployment" />} />
            <Route path="/collaboration-request" element={<FormPage kind="collaboration-request" />} />
            <Route path="/adoption-request" element={<FormPage kind="adoption-request" />} />
            <Route path="/partnership-request" element={<PartnershipRequest />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </RoleProvider>
    </div>
  );
}

export default App;
